import type { Card } from '../../types';

/** Two dice, two hits — composed `damage` effects (ADR-0015 §3). */
export const DOUBLE_STRIKE: Card = {
  id: 'double-strike',
  name: 'Double Strike',
  type: 'attack',
  rarity: 'common',
  size: { w: 2, h: 1 },
  cost: [
    { kind: 'min', value: 2 },
    { kind: 'min', value: 2 },
  ],
  effects: [
    { kind: 'damage', amount: 3 },
    { kind: 'damage', amount: 3 },
  ],
};
